// The view-mode bar (2026-09-25): one slim line on top of every page while an
// admin views as someone. Who, which role, that nothing is saved, and the way
// back. When a page tries to save, the note says it was not saved for a moment.
import { useEffect, useState } from 'react';
import { ArrowLeft, Eye } from 'lucide-react';
import { BLOCKED_EVENT } from './viewAsApi';

const NOTE = 'View only. Nothing you do here is saved.';
const BLOCKED_NOTE = 'That would change their data, so it was not saved.';

export default function ViewAsBanner({ viewAs, onExit, backLabel = 'Back to admin' }) {
  const [blocked, setBlocked] = useState(false);
  useEffect(() => {
    let timer;
    const onBlocked = () => {
      setBlocked(true);
      clearTimeout(timer);
      timer = setTimeout(() => setBlocked(false), 4000);
    };
    window.addEventListener(BLOCKED_EVENT, onBlocked);
    return () => { window.removeEventListener(BLOCKED_EVENT, onBlocked); clearTimeout(timer); };
  }, []);
  const role = viewAs.kind === 'teacher' ? 'Teacher' : 'Student';
  return (
    <div className="bb-viewas-bar" role="region" aria-label="View mode" data-blocked={blocked ? 'true' : undefined}>
      <Eye className="bb-viewas-icon" size={16} strokeWidth={2.25} aria-hidden="true" />
      <p className="bb-viewas-text">
        <span className="bb-viewas-who">Viewing as <strong>{viewAs.name}</strong></span>
        <span className="bb-viewas-role">· {role}</span>
        <span className="bb-viewas-note" aria-live="polite">{blocked ? BLOCKED_NOTE : NOTE}</span>
        <span className="bb-viewas-short" aria-hidden="true">View only</span>
      </p>
      <button type="button" className="bb-viewas-exit" onClick={onExit} aria-label={backLabel}>
        <ArrowLeft size={14} strokeWidth={2.5} aria-hidden="true" />
        <span className="bb-viewas-exit-long">{backLabel}</span>
        <span className="bb-viewas-exit-short">Exit</span>
      </button>
    </div>
  );
}
